export default "/static/images/build_base_6.png?2f84ef847f65149fb7a581bb779a5bc8";